"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExpandNodeIds = exports.flatNodeTree = exports.genarateExpandedKeys = exports.findNode = exports.collectProperty = void 0;
const config_1 = require("../config");
// Collect the ids of all nodes under the specified node (including itself)
const collectProperty = (treeNodesMap, rootId) => {
    const node = treeNodesMap[rootId];
    if (!node) {
        return [rootId];
    }
    const findId = (node) => {
        return node.children.reduce((prev, nodeId) => {
            prev.push(nodeId);
            if (treeNodesMap[nodeId]) {
                prev.push(...findId(treeNodesMap[nodeId]));
            }
            return prev;
        }, []);
    };
    return [node.nodeId, ...findId(node)];
};
exports.collectProperty = collectProperty;
/**
 * Find the specified node
 * @param tree directory tree
 * @param nodeId Node ID to look up
 */
const findNode = (tree, nodeId) => {
    return tree.reduce((preValue, item) => {
        if (preValue) {
            return preValue;
        }
        if (item.nodeId === nodeId) {
            return item;
        }
        if (item.children) {
            return (0, exports.findNode)(item.children, nodeId);
        }
        return null;
    }, null);
};
exports.findNode = findNode;
/**
 * Generate expansion paths based on nodes
 * @param tree directory tree
 * @param expandedKeys array of expanded nodes
 * @param nodeId node ID
 */
function genarateExpandedKeys(treeNodesMap, expandedKeys, nodeId) {
    const expanded = [];
    while (treeNodesMap[nodeId].parentId !== '0') {
        const parentId = treeNodesMap[nodeId].parentId;
        if (!expandedKeys.includes(parentId) && treeNodesMap[parentId].type !== config_1.ConfigConstant.NodeType.ROOT) {
            expanded.push(parentId);
        }
        nodeId = parentId;
    }
    return expanded.reverse();
}
exports.genarateExpandedKeys = genarateExpandedKeys;
/**
 * Flatten the tree (convert the tree structure into a one-dimensional array)
 * @param nodeTree tree of type INode
 */
const flatNodeTree = (nodeTree) => {
    return nodeTree.reduce((prev, item) => {
        prev.push(item);
        if (Array.isArray(item.children) && item.children.length > 0) {
            prev.push(...(0, exports.flatNodeTree)(item.children));
        }
        return prev;
    }, []);
};
exports.flatNodeTree = flatNodeTree;
// Get the expansion path
const getExpandNodeIds = (data, nodeId, end = null, favoriteTreeNodeIds = []) => {
    const expandNodeIds = [];
    // If the chain is found to be broken when searching up the chain recursively, give up this operation directly
    if (!data[nodeId]) {
        return [];
    }
    if (data[nodeId].type === config_1.ConfigConstant.NodeType.ROOT) {
        return expandNodeIds;
    }
    if (favoriteTreeNodeIds.includes(nodeId))
        return expandNodeIds;
    const parentNodeId = data[nodeId].parentId;
    if (parentNodeId !== end) {
        expandNodeIds.push(parentNodeId, ...(0, exports.getExpandNodeIds)(data, parentNodeId, end, favoriteTreeNodeIds));
    }
    return expandNodeIds;
};
exports.getExpandNodeIds = getExpandNodeIds;
//# sourceMappingURL=tree.js.map